<template>
	<b-form-group label="Estado Sucursal">
		<b-input-group >
			<b-form-select
				@input="manageGetHolidays()"
				autocomplete="off"
				:options="statusOptions"
				v-model="selectedStatus"
			></b-form-select>
		</b-input-group>
	</b-form-group>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import {
	BFormInput,
	BFormGroup,
	BInputGroupAppend,
	BInputGroup,
	BButton,
	BFormSelect,
} from 'bootstrap-vue'
export default {
	components: {
		BFormGroup,
		BFormInput,
		BInputGroupAppend,
		BInputGroup,
		BButton,
		BFormSelect,
	},
	data() {
		return {
			statusOptions: [
				{value: null, text: 'Seleccionar...'},
				{value: 'true', text: 'Completo'},
				{value: 'false', text: 'Parcial'},
			]
		}
	},
	computed: {
		selectedStatus: {
			set(value) {
				this.setSelectedStatus(value)
			},
			get() {
				return this.$store.state.tableFilters.selectedStatus
			},
		},
	},
	methods: {
		manageGetHolidays() {
			this.$emit('getHolidays')
		},
		...mapActions('holidays', ['getHolidays']),
		...mapMutations('tableFilters', ['setInput', 'setSelectedStatus']),
		cleanSearchBar() {
			this.setInput(null)
		},
	},
}
</script>
